import { call, put, takeLatest } from "redux-saga/effects";
import { getRevenuesApi } from "../../../../api/dashboard";
import { IBaseResponse } from "../../../../interfaces/base";
import { IFetchDashboardRevenuesAction } from "../../../../interfaces/store/dashboard-interface";
import {
  getRevenuesStart,
  getRevenuesFailed,
  getRevenuesSuccess,
  getSixMonthsRevenuesSuccess,
} from "./revenues-slice";

function* _getRevenues({ payload }: IFetchDashboardRevenuesAction) {
  try {
    const { trainerId, pagination, isSixMonths } = payload;
    const response: IBaseResponse = yield call(
      getRevenuesApi,
      {
        pagination,
        filter: {},
        sort: {
          sortBy: "createdAt",
          sortOrder: 1,
        },
      },
      trainerId
    );

    if (response.error) {
      yield put(getRevenuesFailed(response.error));
    } else {
      if (isSixMonths) {
        yield put(
          getSixMonthsRevenuesSuccess({
            data: response.data,
          })
        );
      } else {
        yield put(
          getRevenuesSuccess({
            data: response.data,
          })
        );
      }
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(getRevenuesFailed({ message: error.message }));
  }
}

function* dashboardSaga() {
  yield takeLatest(getRevenuesStart.type, _getRevenues);
}

export default dashboardSaga;
